import { GLOBALS } from 'utils/generic/global-variables';

const LINK =
  GLOBALS.appConfigs.statisticsLinkLogoV3 ||
  'https://statistics.betconstruct.com';

export const TEAM_LOGO_LINK = `${LINK}/images/e/`;
export const COMPETITION_LOGO_LINK = `${LINK}/images/c/`;
